/**
 * Payme super app (`payme.insonuchun.uz`) host adapter.
 *
 * Payme login boshqa hostlardan farqli:
 *   - Cookie yoki session payload talab qilmaydi — body'siz POST jo'natiladi
 *   - Server avtomatik Payme kontekstida token qaytaradi
 *   - Response strukturasi Click/Telegram dan farq qiladi (`user` nested ob'ekti bor)
 */

import { apiPost } from "@/api/client";
import { setToken } from "@/lib/auth";
import type { HostAdapter, LoginResponse, VendorLoginResponse } from "./types";
import { mapVendorResponse } from "./types";

export const paymeHost: HostAdapter = {
  id: "payme",
  brandId: "payme",

  match() {
    if (typeof window === "undefined") return false;
    return (
      window.location.hostname === "payme.insonuchun.uz"  
      ||
      window.location.hostname === "localhost"                             
    );
  },

  async login(): Promise<LoginResponse> {
    // Body yo'q — server Payme kontekstini o'zi aniqlaydi
    const raw = await apiPost<VendorLoginResponse>("/MiniApp/PaymeLogin");
    setToken(raw.token);
    return mapVendorResponse(raw);
  },
};
